import { apiRequest } from "@common/api";
import type { Picture } from "./dashboard";

// A player's own profile in play-api: what they chose to show. Everyone's
// comes back in the dashboard feed.

export interface Profile {
  picture: Picture | null;
}

export async function myProfile(): Promise<Profile> {
  return (await apiRequest("/profile")).json();
}

export async function saveMyProfile(profile: Profile): Promise<Profile> {
  return (
    await apiRequest("/profile", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(profile),
    })
  ).json();
}
